import React from "react"
import { graphql } from "gatsby"
import { withPrismicPreview } from "gatsby-plugin-prismic-previews"
//import Seo from "../components/seo"
import PubSub from "pubsub-js"
import Cookies from "js-cookie"
import Seo from "../components/seo-helmet"

//import Layout from "../components/layout"
import HomeGrid from "../components/home-grid"
import ThreeWrapper from "../components/ui/3d/ThreeWrapper"
// import Star from "../components/ui/star"
// import Menu from "../components/ui/menu"
//import Intro from "../components/intro"

// import favicon from '../images/favicon.png';

export const pageQuery = graphql`
  query homePageByLocale($locale: String!) {
    general: prismicGeneral {
      ..._prismicGeneral
    }
    homepage: prismicHomepage(lang: { eq: $locale }) {
      _previewable
      data {
        projects {
          project {
            isBroken
            document {
              ... on PrismicProjects {
                uid
                data {
                  ...projectCard
                }
              }
            }
          }
        }
      }
    }
  }
`

class PageHome extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      bodyClass: "loading",
      //bodyClass: '',
      mainClass: "",
      index: 0,
    }
    this._onIntroStart = this._onIntroStart.bind(this)
    this._onIntroEnd = this._onIntroEnd.bind(this)
    this._handleMove = this._handleMove.bind(this)
  }

  componentWillUnmount() {
    // PubSub.unsubscribe('INTRO_START', this._onIntroStart)
    // PubSub.unsubscribe('INTRO_END', this._onIntroEnd)
    document.removeEventListener("mousemove", this._handleMove)
    clearInterval(this.timerEnd)
    clearTimeout(this.timerStart)
    document.body.classList.remove(this.state.bodyClass)
  }

  componentWillMount() {}

  componentDidMount() {
    // PubSub.subscribe('INTRO_START', this._onIntroStart)
    // PubSub.subscribe('INTRO_END', this._onIntroEnd)
    document.body.classList.add(this.state.bodyClass)
    this._handleIntro()
  }

  componentDidUpdate(prevProps, prevState) {
    // Body classes drive the intro animation (see _home.scss)
    if (prevState.bodyClass !== this.state.bodyClass) {
      document.body.classList.remove(prevState.bodyClass)
      document.body.classList.add(this.state.bodyClass)
    }
  }

  _handleIntro() {
    if ("ontouchstart" in window) {
      this.setState({
        bodyClass: "reveal",
      })
      return
    }

    const _seenIntro = Cookies.get("_seenIntro")
    // //const _seenIntro = undefined
    // //console.log(_seenIntro)
    if (!_seenIntro && typeof document !== "undefined") {
      const { notions } = this.props.data.general.data
      const total = notions.length

      document.addEventListener("mousemove", this._handleMove)

      this.timerStart = setTimeout(() => {
        this.setState({
          _seenIntro: false,
          bodyClass: "is-intro",
          total: total,
        })

        PubSub.publish("INTRO_START")

        this.timerEnd = setInterval(() => {
          if (this.state.index + 1 < notions.length) {
            this.setState({
              index: this.state.index + 1,
            })
          } else {
            this._onIntroEnd()
          }
        }, 1000)
      }, 2000)

      var date = new Date()
      var minutes = 30
      date.setTime(date.getTime() + minutes * 60 * 1000)

      Cookies.set("_seenIntro", true, {
        path: "/",
        expires: date,
      })
    } else {
      this.setState({
        _seenIntro: true,
        bodyClass: "reveal",
      })
    }
  }

  _handleMove() {
    document.removeEventListener("mousemove", this._handleMove)
    clearInterval(this.timerEnd)
    clearTimeout(this.timerStart)
    //clearTimeout(this.timerEnd)
    this._onIntroEnd()
  }

  _onIntroStart() {
    this.setState({
      bodyClass: "is-intro",
    })
  }
  _onNotion(e, d) {}
  _onIntroEnd() {
    PubSub.publish("INTRO_END")
    this.setState({
      bodyClass: "reveal",
    })
  }

  render() {
    const { homepage } = this.props.data
    //console.log(general.data.site_description.text)
    // console.log(homepage)

    return (
      <>
        <div className="page-home">
          <HomeGrid data={homepage.data} />
          <ThreeWrapper
            src={"/3d/v4/Rock_04_V1.obj"}
            mtl={"/3d/v4/Rock_04_V1.mtl"}
            texPath="/3d/v4/"
          />
        </div>

        {/* {bodyClass === "is-intro" && <Star total={total} index={index} />} */}
      </>
    )
  }
}

export default withPrismicPreview(PageHome)

export const Head = ({ data: { general }, pageContext: { locale } }) => (
  <Seo
    title={general.data.site_title.text}
    desc={general.data.site_description.text}
    locale={locale}
  />
)
